import { render, staticRenderFns } from "./app-control-aside.vue?vue&type=template&id=3661fa59&"
import script from "./app-control-aside.vue?vue&type=script&lang=js&"
export * from "./app-control-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "app-control-aside.vue"
export default component.exports